import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { AuthProvider } from "@/hooks/useAuth";
import { installConsentDefaults } from "@/lib/consent";
import { captureAttributionFromUrl } from "@/lib/attribution";
import { useCurrencyStore } from "@/lib/currency";
import "./index.css";

// Must run before any tag manager / pixel loads.
installConsentDefaults();
captureAttributionFromUrl();

// Detect IP-based currency + fetch FX rates. Deferred until after first paint
// to keep these third-party requests out of the critical network chain.
const initCurrency = () => useCurrencyStore.getState().initialize();
if (typeof window !== "undefined") {
  const w = window as any;
  if ("requestIdleCallback" in w) {
    w.requestIdleCallback(initCurrency, { timeout: 4000 });
  } else {
    setTimeout(initCurrency, 2500);
  }
}

createRoot(document.getElementById("root")!).render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
